var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    [
      _c("td", [
        _c("div", { staticClass: "grid" }, [
          _c("div", { staticClass: "grid__col--2" }, [
            _c(
              "div",
              { class: "chartColor__box chartColor__box--" + _vm.title },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "grid__col--10" }, [
            _vm._v(_vm._s(_vm.title))
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.validLocations, function(location) {
        return _c("td", { key: location.location_id }, [
          _vm._v(_vm._s(location.totals[_vm.locationProperty]))
        ])
      }),
      _vm._v(" "),
      _vm._l(_vm.extraLocations, function(location) {
        return _c("td", [_vm._v(" ")])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }